/**
 * Common button component
 * 
 * Properties:
 * 
 *      placeholder:        string, placeholder for select-box
 *      zIndex:             number, optional z-index to control UI overlapping
 *      selectHandle:       function, callback to trigger actions after selecting an item
 *      queryHandle:        function, callback to trigger search query
 *      data:               array of objects with at least attributes:
 *                              name:   string, default displayed value in list (can be replaced by 'nameAttribute')
 *                              id:     id of item to re-identify it in list
 *      nameAttribute:      string, attribute to display in result list (optional)
 */

 import React, { useState, useEffect } from "react";

 type Props = {
     disabled?: boolean,
     selectHandle?: (item?: any) => void,
     queryHandle?: (item?: any) => void,
     removeHandle?: (item?: any) => void,
     value?: any,
     data?: any,
     nameAttribute?: string,
     zIndex?: string|null,
     placeholder?: string,
     ownStyle?: React.CSSProperties
 };

 const Select2 = ({disabled=false,selectHandle,queryHandle,removeHandle,value,data,nameAttribute, zIndex, placeholder='',ownStyle={}}: Props) => {

    // current selected item
    const [selectedItem,setSelectedItem] = useState(undefined);
    // current state of select box (if it's open value in input field)
    const [selectState,setSelectState] = useState({
        isOpen: false,
        value: (selectedItem == null || false) ? '' : selectedItem
    });

    // event handler called when an item has been selected or unselected
    const selectHandleLocal = (item: any) => {
        setSelectedItem(item === null ? null : item);

        if (item !== null) {
            querySelectHandle(null,'');
            if (typeof selectHandle === 'function') selectHandle(item);
        } else {
            if (typeof removeHandle === 'function') removeHandle();
        }
    };

    useEffect(() => {
        setSelectedItem(value);
    }, [value])
    
    // setting value will override events target value, used to manually trigger requests
    const querySelectHandle = (e: React.ChangeEvent<HTMLInputElement>|null,value?: any) => {

        const val = typeof value === 'undefined' ? (e !== null?e.target.value:'') : value;

        setSelectState({
            value: val,
            isOpen: (val.length > 0)
        });

        if (typeof queryHandle === 'function') queryHandle(val);
    }
    return (
        <div 
            className={"inbooma-select-box" + (selectState.isOpen ? '' : ' close')} 
            style={{zIndex: (typeof zIndex === 'undefined' || zIndex === null) ? ('' + zIndex) : '1'}}
        >
            <input className="inbooma-select-box__input input-react" 
                   placeholder={placeholder} 
                   value={selectedItem == null ? selectState.value : (nameAttribute  && typeof selectedItem[nameAttribute] !== 'undefined' ? selectedItem[nameAttribute] : selectedItem['name'])}
                   style={(selectedItem !== undefined && selectedItem !== null) ? {background: '#fff',border: '1px solid #e3e3e3',fontSize: '0.9rem',color: '#3b3b3b'} : {}}
                   onClick={() => {setSelectState({...selectState, isOpen : true})}}
                   onBlur={() => {setSelectState({...selectState, isOpen : false})}}
                   disabled={disabled}
                   onChange={(e: React.ChangeEvent<HTMLInputElement>) => {querySelectHandle(e)}} />
            {selectedItem !== undefined && selectedItem !== null &&
                <a href="#" className="inbooma-select-box__reset" onClick={() => selectHandleLocal(null)} style={{paddingRight:'5px', paddingTop:'2px'}}>
                x
                </a>
            }
            {typeof data !== 'undefined' && data !== null && typeof data.length !== 'undefined' &&
                <ul className={"inbooma-select-box-results" + (selectState.isOpen ? '' : ' hidden')} style={ownStyle}>
                    {data.map((element:any) => {
                        return (
                        <li className={"inbooma-select-box-results__field" + (typeof selectedItem !== 'undefined' && selectedItem != null && selectedItem['id']== element.id ? ' selected' : '')}
                            key={element['id']} value={nameAttribute && typeof element[nameAttribute] !== 'undefined' ? element[nameAttribute] : element.name}
                            onClick={() => { selectHandleLocal(element) }}>
                                <span style={{paddingRight:'10px'}}>{nameAttribute && typeof element[nameAttribute] !== 'undefined' ? element[nameAttribute] : element.name}</span>
                        </li>
                        );
                    })}
                </ul>
            }
        </div>
    );
 };
 export default Select2;